var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolderOffFill = function SvgFolderOffFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.775 18.95 6.85 4h2.025a1.98 1.98 0 0 1 1.4.575L11.7 6H20q.824 0 1.413.588Q22 7.175 22 8v10q0 .275-.05.512a1.3 1.3 0 0 1-.175.438M4 20q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18V6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4l2 2H3.2L1.4 4.2a.98.98 0 0 1-.287-.687A.93.93 0 0 1 1.4 2.8a.95.95 0 0 1 .7-.275q.425 0 .7.275l18.4 18.4q.3.3.288.7t-.313.7q-.3.276-.7.287a.92.92 0 0 1-.7-.287l-2.6-2.6z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolderOffFill);
export { ForwardRef as ReactComponent };